module.exports = __webpack_public_path__ + "img/warning.7650174d.svg";